module.exports = __webpack_public_path__ + "static/make-video-slide4-43f15298fdd0e37f8df8ae7947491a61.png";